import { Pipe, PipeTransform } from '@angular/core';
import { getByPath, normalizeForExport } from './object-utils';

@Pipe({ name: 'jsonForKey' })
export class JsonForKeyPipe implements PipeTransform {
  transform(row: any, key: string): string {
    const v = getByPath(row, key);
    const n = normalizeForExport(v);
    return typeof n === 'object' ? JSON.stringify(n) : String(n);
  }
}
